import { format as formatDate } from 'date-fns';

export const formatTravelDateLabel = (date: Date, lang: string): string => {
  if (lang.startsWith('zh')) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return `${year}年${month}月${day}日`;
  }

  return formatDate(date, 'MMM d, yyyy');
};

/** `至` under zh, set unspaced as in 2026年7月16日至2026年8月18日 (CMS-1855). */
export const getTravelDateRangeSeparator = (lang: string): string =>
  lang.startsWith('zh') ? '至' : ' - ';

export const formatTravelDateRangeLabel = (
  startDate: Date,
  endDate: Date | null,
  lang: string,
): string => {
  const startLabel = formatTravelDateLabel(startDate, lang);

  if (!endDate) {
    return startLabel;
  }

  return `${startLabel}${getTravelDateRangeSeparator(lang)}${formatTravelDateLabel(endDate, lang)}`;
};
